import { Route } from 'react-router-dom';
import { ListLendersPage } from './list-lenders';
import { ViewLenderPage } from './view-lender';
import { RequireAuth } from '/src/components';

export { ListLendersPage, ViewLenderPage };

export const lendersRoutes: React.ReactElement[] = [
  <Route
    path="/investors"
    element={
      <RequireAuth>
        <ListLendersPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/investors/:lenderId"
    element={
      <RequireAuth>
        <ViewLenderPage />
      </RequireAuth>
    }
  />,
];
